import {WizardState} from '../../kamona/model/kamonal-model';

export enum PrimerCardType {
	COLOURED = 'COLOURED',
	PLAIN = 'PLAIN',
}

export interface PrimerCard {
	title: string;
	steps: KycStep[];
}

export const StaffSizes = [
	{label: 'Less than 10', value: 'CATEGORY_A'},
	{label: '10 - 49', value: 'CATEGORY_B'},
	{label: '50 - 249', value: 'CATEGORY_C'},
	{label: 'More than 250', value: 'CATEGORY_D'},
];

export interface KycStep {
	status: boolean;
	name: string;
	route?: string;
	key?: string;
	icon?: string;
	showStep?: boolean;
	currentRoute?: boolean;
	step?: number;
}

export enum KycWizardAction {
	NEXT = 'NEXT',
	PREVIOUS = 'PREVIOUS',
}

export enum KycBusinessType {
	REGISTERED = 'REGISTERED',
	UNREGISTERED = 'UNREGISTERED',
}

export enum KYCFormKeys {
	PERSONAL_INFORMATION = 'has_completed_personal_information',
	FACE_VERIFICATION = 'has_completed_face_verification',
	NEXT_OF_KIN = 'has_completed_next_of_kin_information',
	PROOF_OF_ADDRESS = 'has_proof_of_address',
	RESIDENTIAL_ADDRESS = 'has_completed_residential_address',
	IDENTITY_VERIFICATION = 'has_completed_identity_verification',
	BUSINESS_TYPE = 'has_completed_business_type',
	BUSINESS_INFORMATION = 'has_completed_business_information',
	BUSINESS_ADDRESS = 'has_completed_business_address',
	TRANSACTION_PIN = 'has_business_pin',
	BUSINESS_PROOF_OF_ADDRESS = 'has_business_proof_of_address',
	BUSINESS_DOCUMENT = 'has_completed_business_documentation',
	SIGNATURE_UPLOAD = 'has_uploaded_signature_file',
	SUMMARY = 'has_finished_kyc',
	IDENTITY_VERIFICATION_IN_REVIEW = 'identity_verification_in_review',
	LIVELINESS = 'has_completed_liveliness_verification',
	bvnIdentityVerificationStatus = 'bvnIdentityVerificationStatus',
	providerLivelinessVerificationStatus = 'providerLivelinessVerificationStatus',
	providerIdentityVerificationStatus = 'providerIdentityVerificationStatus',
	CONCLUDE_ONBOARDING = 'has_concluded_onboarding',
	HAS_PROFILE = 'hasProfile'
}

export enum KYCFormRoute {
	PERSONAL_INFORMATION = '/kyc/business-owner/personal-information',
	NEXT_OF_KIN = '/kyc/business-owner/next-of-kin',
	PROOF_OF_ADDRESS = '/kyc/business-owner/proof-of-address',
	ACCOUNT_UPGRADE_SUMMARY = '/kyc/upgrade-account/upgrade-account-form/upgrade-account-summary',
	BUSINESS_ADDRESS_UPGRADE = '/kyc/upgrade-account/upgrade-account-form/upgrade-account-business-address',
	PROOF_OF_ADDRESS_UPGRADE = '/kyc/upgrade-account/upgrade-account-form/upgrade-account-proof-of-address',
	BUSINESS_PROOF_OF_ADDRESS_UPGRADE = '/kyc/upgrade-account/upgrade-account-form/upgrade-account-business-proof-of-address',
	IDENTITY_VERIFICATION = '/kyc/provide-identity-documents',
	META_MAP_UPGRADE_ACCOUNT = '/kyc/upgrade-account/upgrade-account-meta-map',
	IDENTITY_VERIFICATION_UPGRADE = '/kyc/upgrade-account/upgrade-account-identity-verification',
	IDENTITY_VERIFICATION_V2 = '/kyc/identity-verification-details',
	PROVIDE_IDENTITY_DOCUMENTS = '/kyc/provide-identity-documents',
	LOW_LEVEL_ACCOUNT = '/kyc/low-level-account',
	PRIMER = '/kyc',
	UPGRADE_KYC_PRIMER = '/kyc/upgrade-account/upgrade-account-primer',
	RE_UPLOAD_KYC_DOCUMENT_PRIMER = '/kyc/kyc-document-re-upload/kyc-document-re-upload-primer',
	RE_UPLOAD_PROOF_OF_ADDRESS = '/kyc/kyc-document-re-upload/kyc-document-re-upload-form/re-upload-proof-of-address',
	BUSINESS_TYPE = '/kyc/business-information/business-type',
	UNREGISTERED_BUSINESS_UPGRADE_PRIMER = '/kyc/kyc-unregistered-business-upgrade/kyc-unregistered-business-upgrade-primer',
	BUSINESS_INFORMATION = '/kyc/business-information/unregistered-business/business-details',
	UNREGISTERED_BUSINESS_UPGRADE_BUSINESS_INFORMATION = '/kyc/kyc-unregistered-business-upgrade/kyc-unregistered-business-upgrade-form/kyc-registered-business-details',
	BUSINESS_ADDRESS = '/kyc/business-information/unregistered-business/business-address',
	REGISTERED_BUSINESS_ADDRESS = '/kyc/business-information/registered-business/registered-business',
	BUSINESS_PROOF_OF_ADDRESS = '/kyc/business-information/business-proof-of-address',
	BUSINESS_DOCUMENT = '/kyc/business-information/unregistered-business/business-owner-details',
	REGISTERED_BUSINESS_SUPPORTING_DOCUMENT = '/kyc/business-information/registered-business/supporting-documents',
	REGISTERED_BUSINESS_DETAILS = '/kyc/business-information/registered-business/details',
	SUMMARY = '/kyc/business-information/unregistered-business/business-owner-details',
	REGISTERED_BUSINESS_SUMMARY = '/kyc/business-information/registered-business/summary',
}

export interface KYCRequirementViolatedVerification {
	type: string;
	enforce: boolean;
	message: string;
}
export interface KYCRequirementMetadata {
    violatedVerifications: KYCRequirementViolatedVerification[]
}
export interface KYCRequirementJsonMetadata {
    isVerifiable?: boolean;
    estimatedCompletionDate?: Date;
}
export interface KYCRequirement {
    code: string;
    status: string;
    message?: string | null;
    metadata?: KYCRequirementMetadata;
    jsonMetadata?: KYCRequirementJsonMetadata;
}
  
  export interface KYCLevelInfo {
    level: number; 
    status: string; 
    requirements: KYCRequirement[]; 
  }
  
  export interface KYCStanding{
    currentLevel: number;
    levels: KYCLevelInfo[];    
  }

  export interface KycLvl3V3Steps {
    FACE_VERIFICATION?: number;
    ADDRESS_COLLECTION?: number;
    PROOF_OF_ADDRESS_VERIFICATION?: number;
    RESIDENTIAL_PHYSICAL_ADDRESS_VERIFICATION: number;
    INDEMNITY?: number;
  }

  export interface DocumentTypeModel {
	name: string;
	documentType: string;
	sample?: string;
	requirements: string[];
	notes?: string | null;
	verifiable?: boolean;
  }

  export interface ProofOfAddressDocumentType {
	documentTypes: Array<DocumentTypeModel>;
  }

  export enum KYCDocumentType {
	ELECTRICITY_BILL = 'ELECTRICITY_BILL',
	UTILITY_BILL = 'UTILITY_BILL'
  }

  export enum KYCV2DocumentTypes {
	ELECTRICITY_BILL = 'ELECTRICITY_BILL',
	WATER_BILL = 'WATER_BILL',
	BANK_STATEMENT = 'BANK_STATEMENT',
	VOTER_CARD = 'VOTER_CARD',
	SOLICITOR_LETTER = 'SOLICITOR_LETTER',
	TENANCY_AGREEMENT = 'TENANCY_AGREEMENT',
	DRIVER_LICENSE = 'DRIVER_LICENCE',
  }

  export enum DocumentSource {
	USER = 'USER',
	BILL_PAYMENTS = 'BILL_PAYMENTS'
  } 

export const KYCBusinessOwnerInformation: PrimerCard = {
	title: 'Business Owner Information',
	steps: [
		{
			status: false,
			name: 'Personal Details',
			route: KYCFormRoute.PERSONAL_INFORMATION,
			key: KYCFormKeys.PERSONAL_INFORMATION,
			icon: 'personalDetails',
			showStep: true,
			step: 1,
		},
		{
			status: false,
			name: 'Next of KIN Details',
			route: KYCFormRoute.NEXT_OF_KIN,
			key: KYCFormKeys.NEXT_OF_KIN,
			icon: 'nextofkin',
			showStep: true,
			step: 2,
		},
		{
			status: false,
			name: 'Liveliness Check',
			key: KYCFormKeys.LIVELINESS,
			route: KYCFormRoute.PROVIDE_IDENTITY_DOCUMENTS,
			icon: 'identification',
			showStep: true,
			step: 3,
		},
		{
			status: false,
			name: 'Valid ID & ID Verification',
			key: KYCFormKeys.IDENTITY_VERIFICATION,
			route: KYCFormRoute.PROVIDE_IDENTITY_DOCUMENTS,
			icon: 'identification',
			showStep: true,
			step: 3,
		},
		{
			status: false,
			name: 'Address & Proof of Address',
			route: KYCFormRoute.PROOF_OF_ADDRESS,
			key: KYCFormKeys.PROOF_OF_ADDRESS,
			icon: 'address',
			showStep: true,
			step: 4,
		},
	],
};

export const KYCBusinessOwnerUpgradeInformation: PrimerCard = {
	title: 'Business Owner Information',
	steps: [
		{
			status: true,
			name: 'Personal Details',
			key: KYCFormKeys.PERSONAL_INFORMATION,
			icon: 'personalDetails',
			showStep: true,
			step: 1,
		},
		{
			status: true,
			name: 'Next of KIN Details',
			key: KYCFormKeys.NEXT_OF_KIN,
			icon: 'nextofkin',
			showStep: true,
			step: 2,
		},
		{
			status: false,
			name: 'Valid ID & ID Verification',
			key: KYCFormKeys.IDENTITY_VERIFICATION,
			route: KYCFormRoute.IDENTITY_VERIFICATION_UPGRADE,
			icon: 'identification',
			showStep: true,
			step: 3,
		},
		{
			status: false,
			name: 'Address & Proof of Address',
			route: KYCFormRoute.PROOF_OF_ADDRESS_UPGRADE,
			key: KYCFormKeys.PROOF_OF_ADDRESS,
			icon: 'address',
			showStep: true,
			step: 4,
		},
	],
};

export const KycUnregisteredBusinessUpgradeInformation: PrimerCard = {
	title: 'Business Information',
	steps: [
		{
			status: true,
			name: 'Business Details',
			key: KYCFormKeys.BUSINESS_TYPE,
			icon: 'businessDetails',
			showStep: true,
			step: 5,
		},
		{
			status: true,
			name: 'Business Operation Information',
			key: KYCFormKeys.BUSINESS_INFORMATION,
			icon: 'information',
			showStep: true,
			step: 6,
		},
		{
			status: true,
			name: 'Business Address',
			key: KYCFormKeys.BUSINESS_ADDRESS,
			route: KYCFormRoute.BUSINESS_ADDRESS_UPGRADE,
			icon: 'address',
			showStep: false,
			step: 7,
		},
		{
			status: false,
			name: 'Business Proof of Address',
			key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
			route: KYCFormRoute.BUSINESS_PROOF_OF_ADDRESS_UPGRADE,
			icon: 'address',
			showStep: true,
			step: 8,
		},
		{
			status: false,
			name: 'Review',
			key: KYCFormKeys.SUMMARY,
			icon: 'document',
			route: KYCFormRoute.ACCOUNT_UPGRADE_SUMMARY,
			showStep: true,
			step: 9,
		},
	],
};

export const KycRegisteredBusinessUpgradeInformation: PrimerCard = {
	title: 'Business Information',
	steps: [
		{
			status: true,
			name: 'Business Details',
			key: KYCFormKeys.BUSINESS_TYPE,
			route: KYCFormRoute.BUSINESS_TYPE,
			icon: 'businessDetails',
			showStep: true,
			step: 5,
		},
		{
			status: true,
			name: 'Business Operation Information',
			key: KYCFormKeys.BUSINESS_INFORMATION,
			route: KYCFormRoute.REGISTERED_BUSINESS_DETAILS,
			icon: 'information',
			showStep: true,
			step: 6,
		},
		{
			status: false,
			name: 'Business Address',
			key: KYCFormKeys.BUSINESS_ADDRESS,
			route: KYCFormRoute.BUSINESS_ADDRESS,
			icon: 'address',
			showStep: true,
			step: 7,
		},
		{
			status: false,
			name: 'Business Proof of Address',
			key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
			route: KYCFormRoute.BUSINESS_PROOF_OF_ADDRESS,
			icon: 'address',
			showStep: true,
			step: 8,
		},
		{
			status: false,
			name: 'Business Documentation',
			key: KYCFormKeys.BUSINESS_DOCUMENT,
			route: KYCFormRoute.REGISTERED_BUSINESS_SUPPORTING_DOCUMENT,
			icon: 'document',
			showStep: true,
			step: 9,
		},
		{
			status: false,
			name: 'Summary',
			key: KYCFormKeys.SUMMARY,
			route: KYCFormRoute.REGISTERED_BUSINESS_SUMMARY,
			icon: 'document',
			showStep: true,
			step: 10,
		},
	],
};

export const kycUnregisteredBusinessInformation: PrimerCard = {
	title: 'Business Information',
	steps: [
		{
			status: false,
			name: 'Business Details',
			key: KYCFormKeys.BUSINESS_TYPE,
			route: KYCFormRoute.BUSINESS_TYPE,
			icon: 'businessDetails',
			showStep: true,
			step: 5,
		},
		{
			status: false,
			name: 'Business Operation Information',
			key: KYCFormKeys.BUSINESS_INFORMATION,
			route: KYCFormRoute.BUSINESS_INFORMATION,
			icon: 'information',
			showStep: true,
			step: 6,
		},
		{
			status: false,
			name: 'Business Address',
			key: KYCFormKeys.BUSINESS_ADDRESS,
			route: KYCFormRoute.BUSINESS_ADDRESS,
			icon: 'address',
			showStep: true,
			step: 7,
		},
		{
			status: false,
			name: 'Business Proof of Address',
			key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
			route: KYCFormRoute.BUSINESS_PROOF_OF_ADDRESS,
			icon: 'address',
			showStep: true,
			step: 8,
		},
		{
			status: false,
			name: 'Business Signature',
			key: KYCFormKeys.SIGNATURE_UPLOAD,
			icon: 'document',
			route: KYCFormRoute.SUMMARY,
			showStep: true,
			step: 9,
		},
	],
};

export const KycCompletion: any[] = [
	{
		status: false,
		key: KYCFormKeys.PROOF_OF_ADDRESS,
	},
	{
		status: false,
		key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
	},
	{
		status: false,
		key: KYCFormKeys.BUSINESS_DOCUMENT,
	},
	{
		status: false,
		key: KYCFormKeys.BUSINESS_INFORMATION,
	},
	{
		status: false,
		key: KYCFormKeys.IDENTITY_VERIFICATION,
	},
	{
		status: false,
		key: KYCFormKeys.LIVELINESS,
	},
	{
		status: false,
		key: KYCFormKeys.PERSONAL_INFORMATION,
	},
	{
		status: false,
		key: KYCFormKeys.NEXT_OF_KIN,
	},
	{
		status: false,
		key: KYCFormKeys.SIGNATURE_UPLOAD,
	},
];

export const kycRegisteredBusinessInformation: PrimerCard = {
	title: 'Business Information',
	steps: [
		{
			status: false,
			name: 'Business Details',
			key: KYCFormKeys.BUSINESS_TYPE,
			route: KYCFormRoute.BUSINESS_TYPE,
			icon: 'businessDetails',
			showStep: true,
			step: 5,
		},
		{
			status: false,
			name: 'Business Operation Information',
			key: KYCFormKeys.BUSINESS_INFORMATION,
			route: KYCFormRoute.REGISTERED_BUSINESS_DETAILS,
			icon: 'information',
			showStep: true,
			step: 6,
		},
		{
			status: false,
			name: 'Business Address',
			key: KYCFormKeys.BUSINESS_ADDRESS,
			route: KYCFormRoute.BUSINESS_ADDRESS,
			icon: 'address',
			showStep: true,
			step: 7,
		},
		{
			status: false,
			name: 'Business Proof of Address',
			key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
			route: KYCFormRoute.BUSINESS_PROOF_OF_ADDRESS,
			icon: 'address',
			showStep: true,
			step: 8,
		},
		{
			status: false,
			name: 'Business Documentation',
			key: KYCFormKeys.BUSINESS_DOCUMENT,
			route: KYCFormRoute.REGISTERED_BUSINESS_SUPPORTING_DOCUMENT,
			icon: 'document',
			showStep: true,
			step: 9,
		},
		{
			status: false,
			name: 'Business Signature',
			key: KYCFormKeys.SIGNATURE_UPLOAD,
			route: KYCFormRoute.REGISTERED_BUSINESS_SUMMARY,
			icon: 'document',
			showStep: true,
			step: 10,
		},
	],
};

export enum KycBusinessOwnerInformationEnum {
	PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
	NEXT_OF_KIN = 'NEXT_OF_KIN',
	PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
	IDENTITY_VERIFICATION = 'IDENTITY_VERIFICATION',
}

export interface KycResidentialAddress {
	houseAddress: number;
	streetName: string;
	stateId: number;
	lgaId: number;
}

export interface KycNationality {
	stateOfOrigin: number;
	nationalityId: number;
	lgaOfOrigin: number;
}

export class KycBusinessOwnerInformation {
	step?: KycBusinessOwnerInformationEnum;
	route?: string;
	previousRoute?: string;
	state?: WizardState;
	key?: string;

	constructor(step: KycBusinessOwnerInformationEnum) {
		this.step = step;
	}
}

export class KycPersonalInformation extends KycBusinessOwnerInformation implements KycResidentialAddress, KycNationality {
	religion: any;
	employmentStatus: any;
	maritalStatus: any;
	houseAddress: number;
	lgaId: number;
	lgaOfOrigin: number;
	nationalityId: number;
	stateId: number;
	stateOfOrigin: number;
	streetName: string;
	proofOfAddressReference: any;
	personalAddressDocumentType: string;

	constructor() {
		super(KycBusinessOwnerInformationEnum.PERSONAL_INFORMATION);
		this.key = KYCFormKeys.PERSONAL_INFORMATION;
	}
}

export class KycNextOfKin extends KycBusinessOwnerInformation implements KycResidentialAddress, KycNationality {
	houseNumber: number;
	lastName: string;
	firstName: string;
	phoneNumber: string;
	relationship: string;
	dateOfBirth: any;
	houseAddress: number;
	lgaId: number;
	lgaOfOrigin: number;
	nationalityId: number;
	stateId: number;
	stateOfOrigin: number;
	streetName: string;

	constructor() {
		super(KycBusinessOwnerInformationEnum.NEXT_OF_KIN);
		this.key = KYCFormKeys.NEXT_OF_KIN;
	}
}

export class KycProofOfAddress extends KycBusinessOwnerInformation {
	documentType: any;
	proofOfAddressReference: string;
	personalAddressDocumentType: string;
	businessAddressDocumentType: any;
	file: any;

	constructor() {
		super(KycBusinessOwnerInformationEnum.PROOF_OF_ADDRESS);
		this.key = KYCFormKeys.PROOF_OF_ADDRESS;
	}
}

export interface BusinessKycInformation {
	businessMode?: string;
	businessAddress?: string;
	city?: string;
	lgaId?: number;
	businessSubCategoryId?: number;
	isPersonalAddressForBusiness?: boolean;
	accountForOutsideBusinessCategory?: boolean;
	otherBusinessPurpose?: string;
	businessName?: string;
	businessType?: string;
	proofOfAddressReference?: any;
	otherAccountPurpose?: string;
	businessSubCategory?: any;
	businessCategory?: any;
	localGovernment?: any;
	state?: any;
	businessCategoryId?: number;
	businessAddressDocumentType?: string;
	staffSize?: any;
	businessDescription?: any;
	ownershipStructure?: string;
	registeredBusinessType?: any;
	businessOwnerGreaterThanOne?: boolean;
}

export interface KYCRequestData {
	personalInformation?: KycPersonalInformation;
	nextOfKinInformation?: KycNextOfKin;
	proofOfAddress?: KycProofOfAddress;
	businessProofOfAddress?: KycProofOfAddress;
	businessKycInformation?: BusinessKycInformation;
	identityVerificationCount?: number;
	identityVerificationReference?: any;
	identityVerificationSuspensionReleaseTime?: any;
	providerIdentityVerificationStatus?: any;
	bvnIdentityVerificationStatus?: any;
	businessType?: string;
	customer?: any;
	has_business_proof_of_address?: boolean;
	has_completed_business_address?: boolean;
	has_completed_business_documentation?: boolean;
	has_completed_business_information?: boolean;
	has_completed_identity_verification?: boolean;
	has_completed_liveliness_verification?: boolean;
	has_completed_next_of_kin_information?: boolean;
	has_completed_personal_information?: boolean;
	has_proof_of_address?: boolean;
	has_uploaded_signature_file?: boolean;
	registered_business_fields?: RegisteredBusinessDocument;
}

export const kycDocumentTypeData = [
	'VOTER_CARD',
	'DRIVER_LICENCE',
	'UTILITY_BILL',
	'BANK_STATEMENT',
	'SOLICITOR_LETTER',
	'TENANCY_AGREEMENT',
];

export enum KycDocumentType {
	UTILITY_BILL = 'UTILITY_BILL',
	BANK_STATEMENT = 'BANK_STATEMENT',
	VOTER_CARD = 'VOTER_CARD',
	SOLICITOR_LETTER = 'SOLICITOR_LETTER',
	TENANCY_AGREEMENT = 'TENANCY_AGREEMENT',
	DRIVER_LICENSE = 'DRIVER_LICENCE',
	PDF = 'PDF',
}

export enum MetaMapVerificationState {
	IDENTITY_VERIFIED = 'IDENTITY_VERIFIED',
	VERIFYING = 'VERIFYING',
	FAILED_RETRY = 'FAILED_RETRY',
	FAILED_CONTACT_SUPPORT = 'FAILED_CONTACT_SUPPORT',
	FAILED_TOO_MANY_ATTEMPT = 'FAILED_TOO_MANY_ATTEMPT',
	IN_REVIEW = 'IN_REVIEW',
	VERIFICATION_IN_PROGRESS = 'VERIFICATION_IN_PROGRESS',
}

export const META_MAP_CREDENTIALS = {
	clientId: '62332ccfe04004001cf3577c',
	flowId: '631747fea4a5cb001ce36fff',
	id: 'mati_button',
};

export enum KYC_DOCUMENT_TYPE {
	personal = 'personal',
	business = 'business',
}

export interface KycRoute {
	key: string;
	completed?: boolean;
	route?: string;
}

export enum KYCFormPhase {
	BUSINESS_OWNER_INFORMATION = 'business-owner',
	BUSINESS_INFORMATION = 'business-information',
}

export enum RoutePath {
	REGISTERED_BUSINESS = 'registered-business',
	UNREGISTERED_BUSINESS = 'unregistered-business',
}

export const KycUnregisteredBusinessRoutes: KycRoute[] = [
	{
		key: KYCFormKeys.PERSONAL_INFORMATION,
		route: KYCFormRoute.PERSONAL_INFORMATION,
		completed: false,
	},
	{
		key: KYCFormKeys.NEXT_OF_KIN,
		route: KYCFormRoute.NEXT_OF_KIN,
		completed: false,
	},
	{
		key: KYCFormKeys.PROOF_OF_ADDRESS,
		route: KYCFormRoute.PROOF_OF_ADDRESS,
		completed: false,
	},
	{
		key: KYCFormKeys.IDENTITY_VERIFICATION,
		route: KYCFormRoute.PROVIDE_IDENTITY_DOCUMENTS,
		completed: false,
	},
	{
		key: KYCFormKeys.BUSINESS_TYPE,
		route: KYCFormRoute.BUSINESS_TYPE,
		completed: false,
	},
	{
		key: KYCFormKeys.BUSINESS_INFORMATION,
		route: KYCFormRoute.BUSINESS_INFORMATION,
		completed: false,
	},
	{
		key: KYCFormKeys.BUSINESS_ADDRESS,
		route: KYCFormRoute.BUSINESS_ADDRESS,
		completed: false,
	},
	{
		key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
		route: KYCFormRoute.BUSINESS_PROOF_OF_ADDRESS,
		completed: false,
	},
	{
		key: KYCFormKeys.SIGNATURE_UPLOAD,
		route: KYCFormRoute.SUMMARY,
		completed: false,
	},
	{
		key: KYCFormKeys.SUMMARY,
		route: KYCFormRoute.SUMMARY,
		completed: false,
	},
];
export const KycRegisteredBusinessRoutes: KycRoute[] = [
	{
		key: KYCFormKeys.PERSONAL_INFORMATION,
		route: KYCFormRoute.PERSONAL_INFORMATION,
		completed: false,
	},
	{
		key: KYCFormKeys.NEXT_OF_KIN,
		route: KYCFormRoute.NEXT_OF_KIN,
		completed: false,
	},
	{
		key: KYCFormKeys.PROOF_OF_ADDRESS,
		route: KYCFormRoute.PROOF_OF_ADDRESS,
		completed: false,
	},
	{
		key: KYCFormKeys.IDENTITY_VERIFICATION,
		route: KYCFormRoute.PROVIDE_IDENTITY_DOCUMENTS,
		completed: false,
	},
	{
		key: KYCFormKeys.BUSINESS_TYPE,
		route: KYCFormRoute.BUSINESS_TYPE,
		completed: false,
	},
	{
		key: KYCFormKeys.BUSINESS_INFORMATION,
		route: KYCFormRoute.REGISTERED_BUSINESS_DETAILS,
		completed: false,
	},
	{
		key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
		route: KYCFormRoute.BUSINESS_PROOF_OF_ADDRESS,
		completed: false,
	},
	{
		key: KYCFormKeys.BUSINESS_DOCUMENT,
		route: KYCFormRoute.REGISTERED_BUSINESS_SUPPORTING_DOCUMENT,
		completed: false,
	},
	{
		key: KYCFormKeys.SUMMARY,
		route: KYCFormRoute.REGISTERED_BUSINESS_SUMMARY,
		completed: false,
	},
];

export const KycProcessKeys: any[] = [
	'has_completed_business_address',
	'has_completed_business_documentation',
	'has_completed_business_information',
	'has_completed_identity_verification',
	'has_completed_next_of_kin_information',
	'has_completed_personal_information',
	'has_proof_of_address',
	'has_uploaded_signature_file',
];

export interface MetaMapMetaData {
	identityVerificationCount: number;
	providerIdentityVerificationReference: string;
}

export interface MetaMapReference {
	reference: string;
}

export interface MetaMapRefVerificationStatus {
	verified: boolean;
}

export enum MetaMapVerificationStatus {
	VERIFICATION_IN_PROGRESS = 'VERIFICATION_IN_PROGRESS',
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',
	IN_REVIEW = 'IN_REVIEW',
}

export enum BusinessOperationEnum {
	MONEY_AGENT = 'MONEY_AGENT',
	OTHER_BUSINESSES = 'OTHER_BUSINESSES',
	MIXED_USE = ' MIXED_USE',
}

export const MAX_META_MAP_VERIFICATION_PERIOD_IN_MINUTES = 3;

export const KYC_MODAL_CLASS = 'moniepoint-dialog';
export const KYC_MODAL_WIDTH = 396;
export const RECOMMENDED_DOCUMENT_TYPE = 'ELECTRICITY_BILL';

export interface RegisteredBusinessKycInformation {
	businessName: string;
	businessType: string;
	businessSubCategory: any;
	businessCategory: any;
	businessCategoryId?: number;
	businessDescription?: string;
	businessTradingAddress?: string;
	city?: string;
	lgaId?: number;
	businessSubCategoryId: number;
	isPersonalAddressForBusiness: boolean;
	otherBusinessPurpose?: string;
	staffSize: string;
	isAccountForOutsideBusinessCategory: boolean;
	proofOfAddressReference?: any;
	supportingDocument?: any;
}

export interface KYCRegisteredRequestData {
	personalInformation?: KycPersonalInformation;
	nextOfKinInformation?: KycNextOfKin;
	proofOfAddress?: KycProofOfAddress;
	businessProofOfAddress?: KycProofOfAddress;
	registeredBusinessKycInformation?: RegisteredBusinessKycInformation;
}

// export interface supportingDocumentType {
// 	businessNameDocument: 'Business Name Registration',
// 	incorporatedTrusteesDocument: 'Incorporated Trustees'
// }

export const supportingDocument = [
	{
		businessType: 'BUSINESS_NAME',
		fields: [
			{
				name: 'business_number',
				type: 'text',
				label: 'Enter Business Name Number',
				placeHolder: '0000000000000',
				required: true,
			},
			{
				name: 'CERTIFIED_APPLICATION_FORM',
				type: 'file',
				label: 'Upload Certified Application Form',
				placeHolder: '',
				required: true,
			},
			{
				name: 'CERTIFICATE_OF_BUSINESS_NAME',
				type: 'file',
				label: 'Upload Certificate of Business Name',
				placeHolder: '',
				required: true,
			},
			{
				name: 'other_business_owners',
				type: 'radio',
				label: 'Are there other business owners?',
				placeHolder: '',
				required: false,
			},
		],
	},
	{
		businessType: 'INCORPORATED_COMPANY_PRIVATE_A',
		fields: [
			{
				name: 'ownership_structure',
				type: 'dropdown',
				label: 'Ownership Structure',
				placeHolder: '',
				required: true,
			},
			{
				name: 'business_number',
				type: 'text',
				label: '',
				placeHolder: 'RC Number',
				required: true,
			},
			{
				name: 'tin',
				type: 'text',
				label: '',
				placeHolder: 'Tax Identification Number',
				required: true,
			},
			{
				name: 'MEMAT',
				type: 'file',
				label: 'Upload Memorandum of Articles of Association',
				placeHolder: '',
				required: true,
			},
			{
				name: 'CAC_3',
				type: 'file',
				label: 'Form CAC 3',
				placeHolder: '',
				required: true,
			},
			{
				name: 'CAC_2',
				type: 'file',
				label: 'Form CAC 2',
				placeHolder: '',
				required: true,
			},
			{
				name: 'CAC_7',
				type: 'file',
				label: 'Form CAC 7',
				placeHolder: '',
				required: true,
			},
			{
				name: 'INCORPORATION_CETIFICATE',
				type: 'file',
				label: '',
				placeHolder: 'Upload Certificate of Incorporation',
				required: true,
			},
			{
				name: 'BOARD_RESOLUTION',
				type: 'file',
				label: 'Upload Board Resolution',
				placeHolder: '',
				required: true,
			},
		],
	},
	{
		businessType: 'INCORPORATED_COMPANY_PRIVATE_B',
		fields: [
			{
				name: 'ownership_structure',
				type: 'dropdown',
				label: 'Ownership Structure',
				placeHolder: '',
				required: true,
			},
			{
				name: 'business_number',
				type: 'text',
				label: '',
				placeHolder: 'RC Number',
				required: true,
			},
			{
				name: 'tin',
				type: 'text',
				label: '',
				placeHolder: 'Tax Identification Number',
				required: true,
			},
			{
				name: 'INCORPORATION_CETIFICATE',
				type: 'file',
				label: 'Upload Certificate of Incorporation',
				placeHolder: '',
				required: true,
			},
			{
				name: 'BOARD_RESOLUTION',
				type: 'file',
				label: 'Upload Board Resolution',
				placeHolder: '',
				required: true,
			},
		],
	},
	{
		businessType: 'INCORPORATED_COMPANY_PUBLIC',
		fields: [
			{
				name: 'ownership_structure',
				type: 'dropdown',
				label: 'Ownership Structure',
				placeHolder: '',
				required: true,
			},
			{
				name: 'business_number',
				type: 'text',
				label: '',
				placeHolder: 'RC Number',
				required: true,
			},
			{
				name: 'tin',
				type: 'text',
				label: '',
				placeHolder: 'Tax Identification Number',
				required: true,
			},
			{
				name: 'MEMAT',
				type: 'file',
				label: 'Upload Memorandum of Articles of Association',
				placeHolder: '',
				required: true,
			},
			{
				name: 'INCORPORATION_CETIFICATE',
				type: 'file',
				label: 'Upload Certificate of Incorporation',
				placeHolder: '',
				required: true,
			},
		],
	},
	{
		businessType: 'FREE_ZONE_ENTITY',
		fields: [
			{
				name: 'nezpa_number',
				type: 'text',
				label: 'Enter NEZPA Number',
				placeHolder: '',
				required: true,
			},
			{
				name: 'OPERATING_LICENSE',
				type: 'file',
				label: 'Upload Operating License',
				placeHolder: '',
				required: true,
			},
			{
				name: 'TC_NOTICE',
				type: 'file',
				label: 'Upload TC of Notice of Situation',
				placeHolder: '',
				required: true,
			},
			{
				name: 'PARTICULARS_OF_DIRECTORS',
				type: 'file',
				label: 'Particulars of Directors or Any Claim Therein',
				placeHolder: '',
				required: true,
			},
		],
	},
	{
		businessType: 'COOPERATIVE_SOCIETY',
		fields: [
			{
				name: 'COOPERATIVE_CERTIFICATE',
				type: 'file',
				label: 'Upload Cooperative Certificate',
				placeHolder: '',
				required: true,
			},
			{
				name: 'CERTIFIED_APPLICATION_FORM',
				type: 'file',
				label: 'Upload Certified Application Form',
				placeHolder: '',
				required: true,
			},
		],
	},
	{
		businessType: 'INCORPORATED_TRUSTEES',
		fields: [
			{
				name: 'business_number',
				type: 'text',
				label: 'Enter CAC Number',
				placeHolder: '0000000000000',
				required: true,
			},
			{
				name: 'CAC_IT',
				type: 'text',
				label: 'Upload CAC/IT1 Form',
				placeHolder: '',
				required: true,
			},
		],
	},
	{
		businessType: 'GOVERNMENT_ENTITY',
		fields: [
			{
				name: 'COMPANY_LETTER_OF_AUTHORIZATION',
				type: 'file',
				label: 'Upload Company Letter of Authorization',
				placeHolder: '',
				required: true,
			},
			{
				name: 'CAC_IT',
				type: 'text',
				label: 'Upload CAC/IT1 Form',
				placeHolder: '',
				required: true,
			},
		],
	},
	{
		businessType: 'PRIVATE_ENTITY',
		fields: [
			{
				name: 'GOVERNMENT_APPROVAL_DOCUMENT',
				type: 'file',
				label: 'Upload Government Approval Document',
				placeHolder: '',
				required: true,
			},
			{
				name: 'BUSINESS_OWNER_DOCUMENTS',
				type: 'file',
				label: 'Upload Document showing business owners',
				placeHolder: '',
				required: true,
			},
		],
	},
];

export interface RegisteredBusinessDocument {
	boardResolution?: any;
	businessOwnerDocument?: any;
	cac2?: any;
	cac3?: any;
	cac7?: any;
	cacIt?: any;
	certificateOfBusinessName?: any;
	certificateOfIncorporation?: any;
	certifiedApplicationForm?: any;
	companyLetterOfAuthorization?: any;
	cooperativeCertificate?: any;
	governmentApprovalDocument?: any;
	id?: number;
	memat?: any;
	operatingLicense?: any;
	statementOfShareCapital?: any;
	status?: any;
	tcNoticeOfSituation?: any;
	businessOwnerGreaterThanOne?: boolean;
	businessNumber?: any;
	taxIdentificationNumber?: any;
}
